'use client';

import { Wallet } from './Wallet';

/**
 * @deprecated Use the `Wallet` component instead with no 'children' props.
 */
export function WalletDefault() {
  return <Wallet />;
}
